import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

const localStorageKey = 'prefers-color-scheme';

export const useDarkMode = defineStore('darkMode', () => {
  const enabled = ref<boolean>(getPrefersDarkMode());

  watch(enabled, (value) => {
    localStorage.setItem(localStorageKey, value ? 'dark' : 'light');
    setDarkMode(value);
  });

  setDarkMode(enabled.value);

  return {
    enabled
  };
});

function setDarkMode(value: boolean) {
  document.documentElement.classList.toggle('p-dark', value);
}

function getPrefersDarkMode(): boolean {
  const item = localStorage.getItem(localStorageKey);

  switch (item) {
    case 'dark':
      return true;
    case 'light':
      return false;
  }

  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return true;
  }

  return false;
}
